module.exports = __webpack_public_path__ + "img/截图样例.19a338cc.jpg";